import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';

import { APP_PATHS } from 'routes/constants';
import Flow from 'containers/Layout/Flow';
import GeneralError from 'containers/Error/GeneralError/GeneralError';
import PageNotFound from 'containers/Error/PageNotFound/PageNotFound';

export const ActivateAccount = lazy(() =>
  import(
    /* webpackChunkName: "activateAccount" */ 'containers/ActivateAccount/ActivateAccount'
  )
);

export const AlreadyRegistered = lazy(() =>
  import(
    /* webpackChunkName: "alreadyRegistered" */ 'containers/AlreadyRegistered/AlreadyRegistered'
  )
);

export const Confirm = lazy(() =>
  import(/* webpackChunkName: "confirmation" */ 'containers/Confirm/Confirm')
);

export const Contract = lazy(() =>
  import(/* webpackChunkName: "contract" */ 'containers/Contract/Contract')
);

export const EnterZipCodeForm = lazy(() =>
  import(
    /* webpackChunkName: "enterZipCodeForm" */ 'containers/EnterZipCode/EnterZipCodeForm'
  )
);

export const InviteExpired = lazy(() =>
  import(
    /* webpackChunkName: "inviteExpired" */ 'containers/InviteExpired/InviteExpired'
  )
);

// Export global Path references for use in routing, redirection, etc.

const RedirectToEnterZipCode = () => <Redirect to={APP_PATHS.enterZipCode} />;

export const registrationPageTitles = {
  confirm: 'Registration Complete',
  primaryInvite: 'Primary Invite',
};

const routes = [
  {
    path: '/',
    exact: true,
    layout: Flow,
    component: RedirectToEnterZipCode,
  },
  {
    path: APP_PATHS.activateAccount,
    exact: true,
    layout: Flow,
    component: ActivateAccount,
    layoutProps: {
      noClose: true,
    },
    pageTitle: 'Activate Your Account',
  },
  {
    path: APP_PATHS.activateAccountError,
    exact: true,
    layout: Flow,
    component: GeneralError,
    layoutProps: {
      noClose: true,
    },
    pageTitle: 'Sorry, Something Went Wrong',
  },
  {
    path: APP_PATHS.alreadyRegistered,
    exact: true,
    layout: Flow,
    component: AlreadyRegistered,
    layoutProps: {
      noClose: true,
    },
    pageTitle: 'Already Registered',
  },
  {
    path: APP_PATHS.confirm,
    exact: true,
    layout: Flow,
    component: Confirm,
    layoutProps: {
      noClose: true,
    },
    pageTitle: registrationPageTitles.confirm,
  },
  {
    path: APP_PATHS.enterZipCode,
    exact: true,
    layout: Flow,
    component: EnterZipCodeForm,
    layoutProps: {
      noClose: true,
    },
    pageTitle: registrationPageTitles.primaryInvite,
  },
  {
    path: APP_PATHS.enterZipCodeError,
    exact: true,
    layout: Flow,
    component: GeneralError,
    layoutProps: {
      noClose: true,
    },
    pageTitle: 'Sorry, Something Went Wrong',
  },
  {
    path: APP_PATHS.inviteExpired,
    exact: true,
    layout: Flow,
    component: InviteExpired,
    layoutProps: {
      noClose: true,
    },
    pageTitle: 'Invitation Timeout',
  },
  {
    path: APP_PATHS.termsConditions,
    exact: true,
    layout: Flow,
    component: Contract,
    layoutProps: {
      noClose: true,
    },
    pageTitle: 'Terms and Conditions',
  },
  {
    path: '*',
    layout: Flow,
    component: PageNotFound,
    pageTitle: 'Page Not Found',
    layoutProps: {
      noClose: true,
    },
  },
];

export default routes;
